import { render } from "./GroupDataItem.vue?vue&type=template&id=46d50326"
import script from "./GroupDataItem.vue?vue&type=script&lang=js"
export * from "./GroupDataItem.vue?vue&type=script&lang=js"

import "./GroupDataItem.vue?vue&type=style&index=0&id=46d50326&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__